import { put, takeLatest } from 'redux-saga/effects'
import { get } from 'lodash-es'

import { openMod, closeHelperMod } from './mods'

const REQUEST_OPEN_CREATE_COLLECTION = 'REQUEST_OPEN_CREATE_COLLECTION'
const REQUEST_OPEN_EDIT_TAGS = 'REQUEST_OPEN_EDIT_TAGS'

export const requestOpenCreateCollection = cardToAdd => ({
  type: REQUEST_OPEN_CREATE_COLLECTION,
  payload: cardToAdd
})

function* processOpenCreateCollection(action) {
  yield put(closeHelperMod())
  yield put(
    openMod({ type: 'createCollection', args: { transparentBg: true, cardToAdd: get(action, 'payload.cardToAdd') } })
  )
}

function* openCreateCollectionSaga() {
  yield takeLatest(REQUEST_OPEN_CREATE_COLLECTION, processOpenCreateCollection)
}

export const requestOpenEditTags = (id, local) => ({
  type: REQUEST_OPEN_EDIT_TAGS,
  payload: { id, local }
})

function* processOpenEditTags(action) {
  const { id, local } = action.payload

  yield put(closeHelperMod())
  yield put(openMod({ type: 'editTags', href: id, args: { local } }))
}

function* openEditTagsSaga() {
  yield takeLatest(REQUEST_OPEN_EDIT_TAGS, processOpenEditTags)
}

export const sagas = [openCreateCollectionSaga, openEditTagsSaga]
